export class MarkdownParser {
  static parse(text: string): string {
    if (!text || typeof text !== 'string') {
      return text || '';
    }

    let html = text;

    html = html.replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>');
    html = html.replace(/___(.+?)___/g, '<strong><em>$1</em></strong>');
    html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/__(.+?)__/g, '<strong>$1</strong>');
    html = html.replace(/(?<!\*)\*(?!\*)(.+?)(?<!\*)\*(?!\*)/g, '<em>$1</em>');
    html = html.replace(/(?<!_)_(?!_)(.+?)(?<!_)_(?!_)/g, '<em>$1</em>');
    html = html.replace(/~~(.+?)~~/g, '<del>$1</del>');

    const emojiMap: Record<string, string> = {
      smile: '\u{1F604}',
      rocket: '\u{1F680}',
      tada: '\u{1F389}',
    };

    html = html.replace(/:([a-z0-9_+-]+):/g, (match, emojiName: string) => {
      return emojiMap[emojiName] ?? match;
    });

    return html;
  }
}
